import { useEffect, useState } from "react";
import { BasicInfoService } from "../../services/basicinfo/basicinfo.service";
import { FormBankAccountToEdit } from "../forms/formBankAccountToEdit";
import { sanitizarInputNumerico } from "../../utils/validateData";
import {
  contieneCaracteresPeligrosos,
  validarLongitudMaxima,
} from "../../utils/validacionesForms";
import { BottomSheet } from "../new_components/BottomSheet";
import { NextButton } from "../new_components/buttonsFlow";
import { homologateBankNameAccount } from "../../utils/options_selects";
import { reintentarUsuarioComments } from "../../utils/commentsValidate";
import * as url from "../../helpers/url_helper";
import { APIClient } from "../../helpers/api_helper";

const apiClient = new APIClient();

export function EditBankAccountDialog({
  dialogOpen,
  setDialogOpen,
  _state,
  setState,
  refreshAccounts,
  accountToEdit,
  handleOpenAlert,
}) {
  const [errorField, setErrorField] = useState({});
  const [disableBtn, setDisableBtn] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [openDialogAlert, setOpenDialogAlert] = useState(false);
  const [disbursementStatus] = useState(
    localStorage.getItem("disbursementStatus"),
  );

  const clearStateBankAccount = () => {
    setState({
      bankAccount: "",
      typeBankAccount: "",
      accountNumber: "",
      parent: false,
    });
  };

  const handleOpenSnackbar = (type, message, isOpen) => {
    handleOpenAlert(type, message, isOpen);
  };

  const handleToggleDialog = () => {
    if (dialogOpen) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
    setErrorField({});
    clearStateBankAccount();
  };

  const validateData = () => {
    // MITIGACIÓN VUL-03: Validar longitud máxima (Buffer Overflow)
    const MAX_ACCOUNT_LENGTH = 15;
    if (
      validarLongitudMaxima(_state.accountNumber, MAX_ACCOUNT_LENGTH) === false
    ) {
      handleOpenSnackbar(
        "error",
        `El número de cuenta no puede superar los ${MAX_ACCOUNT_LENGTH} dígitos.`,
        true,
      );
      return false;
    }

    // MITIGACIÓN VUL-03: Validar Inyección (Solo números permitidos)
    const soloNumerosRegex = /^[0-9]+$/;
    if (!soloNumerosRegex.test(_state.accountNumber)) {
      handleOpenSnackbar(
        "error",
        "El número de cuenta contiene caracteres inválidos.",
        true,
      );
      return false;
    }

    // MITIGACIÓN VUL-03: Validar que el Banco y Tipo no tengan inyecciones
    if (
      contieneCaracteresPeligrosos(_state.bankAccount) ||
      contieneCaracteresPeligrosos(_state.typeBankAccount)
    ) {
      handleOpenSnackbar("error", "Datos de banco inválidos.", true);
      return false;
    }

    const newErrors = {};
    let hasValidate = true;
    if (
      _state.typeBankAccount === "Seleccione una opción." ||
      _state.typeBankAccount === ""
    ) {
      newErrors.typeBankAccount = "Debe seleccionar una opción válida.";
    } else if (_state.accountNumber.length === 0) {
      newErrors.accountNumber = "Ingrese un numero de cuenta válido.";
    } else if (
      _state.bankAccount === "Seleccione una opción." ||
      _state.bankAccount === ""
    ) {
      newErrors.bankAccount = "Debe seleccionar una opción válida.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorField(newErrors);
      hasValidate = false;
    } else {
      setErrorField({});
    }
    return hasValidate;
  };

  const hasChanges = () => {
    if (!accountToEdit) return true; // por seguridad

    return (
      _state.bankAccount !==
        homologateBankNameAccount(accountToEdit?.bankAccount, "value") ||
      _state.typeBankAccount !== accountToEdit.typeBankAccount ||
      sanitizarInputNumerico(_state.accountNumber) !==
        sanitizarInputNumerico(accountToEdit.accountNumber)
    );
  };

  const handlesubmit = async () => {
    try {
      setDisableBtn(true);

      let __error;
      let __message;
      let hasValidate = validateData();
      if (!hasValidate) return;
      _state.accountNumber = sanitizarInputNumerico(_state?.accountNumber);

      let { error, message } = await BasicInfoService.updateBankAccount(
        localStorage.getItem("doc"),
        { bankAccount: _state },
      );
      __error = error;
      __message = message;

      if (__error) {
        return handleOpenSnackbar(
          "error",
          __message?.message ||
            "Ha ocurrido un error inesperado, por favor intenta más tarde.",
          true,
        );
      }
      handleOpenSnackbar(
        "success",
        "¡Hemos actualizado tu cuenta bancaria con éxito!.",
        true,
      );

      let disbursementComment = localStorage.getItem("disbursementComment");
      let credit_id = localStorage.getItem("credit_id");
      await refreshAccounts();
      if (
        reintentarUsuarioComments.includes(disbursementComment) &&
        disbursementStatus === "Fallido" &&
        _state.parent === true
      ) {
        retryDisbursement(credit_id);
      }

      setDialogOpen(false);
      clearStateBankAccount();
      return;
    } catch (error) {
      console.log(error?.message);
    } finally {
      setDisableBtn(false);
    }
  };

  const retryDisbursement = async (credit_id) => {
    try {
      if (!credit_id) return {};
      const { data } = await apiClient.create(url.RETRY_DISBURSEMENT, {
        idcredito: credit_id,
      });
      let _disbursementData = data?.data;
      if (_disbursementData?.success) return _disbursementData ?? {};
    } catch (error) {
      console.error(error);
      return {};
    }
  };

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  return (
    <>
      <BottomSheet
        open={dialogOpen}
        isDesktop={!isMobile}
        onOpenChange={handleToggleDialog}
        headerContent={
          <div>
            <h1 className="font-semibold2 text-xl">
              Actualizar cuenta bancaria
            </h1>
          </div>
        }
        footerContent={
          <div className="flex items-center justify-center gap-5 h-16">
            {openDialogAlert ? (
              <>
                <NextButton
                  finishLabel={"Confirmar"}
                  isLastStep={true}
                  showIconNext={false}
                  onNext={(e) => {
                    handlesubmit(e);
                    setOpenDialogAlert(false);
                  }}
                  disabled={disableBtn}
                  isUnicButtom={true}
                />
              </>
            ) : (
              <>
                <NextButton
                  finishLabel={"Actualizar banco"}
                  isLastStep={true}
                  showIconNext={false}
                  onNext={(e) => {
                    if (!hasChanges()) {
                      handleOpenSnackbar(
                        "warning",
                        "No has realizado ningún cambio en la cuenta.",
                        true,
                      );
                      setDialogOpen(false);
                      return;
                    }
                    if (disbursementStatus === "Fallido") {
                      setOpenDialogAlert(true);
                      return;
                    }
                    handlesubmit(e);
                  }}
                  disabled={disableBtn}
                  isUnicButtom={true}
                />
              </>
            )}
          </div>
        }
      >
        <div className="mt-2 flex flex-col items-center">
          <p className="font-semibold2 text-xl text-center">
            Actualiza la información de tu cuenta bancaria
          </p>

          <FormBankAccountToEdit
            _state={_state}
            setState={setState}
            errorField={errorField}
            accountToEdit={accountToEdit}
          ></FormBankAccountToEdit>
        </div>
      </BottomSheet>
    </>
  );
}
